import React, { useState } from 'react';
import { Container } from './styled';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDatePicker from 'react-datepicker';

const DateInput = ({ onValueSelect }) => {
  const [startDate, setStartDate] = useState(new Date());

  const onChange = (date) => {
    setStartDate(date);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateString = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    onValueSelect(dateString);
  };
  return (
    <Container>
      <ReactDatePicker
        open
        selected={ startDate }
        onSelect={ date => onChange(date) }
        dateFormat="yyyy-MM-dd"
        placeholderText="YYYY-MM-DD"
      />
    </Container>
  );
};

export default DateInput;
